// @ts-check
import { api } from "../client.js";

/** Endpoints do módulo comercial. */
export const leadsApi = {
  /** @param {{ search?: string, status?: string, origin?: string }} [filtros] */
  list: (filtros) => api.get("/leads", filtros),

  origins: () => api.get("/leads/origins"),

  /** Resumo das conversas para a inbox. */
  conversations: () => api.get("/leads/conversations"),

  /** Compromissos da agenda (anotações com data de retorno). */
  agenda: () => api.get("/leads/agenda"),

  /** @param {string} id */
  find: (id) => api.get(`/leads/${id}`),

  /** @param {object} dados */
  create: (dados) => api.post("/leads", dados),

  /** @param {string} id @param {object} patch */
  update: (id, patch) => api.patch(`/leads/${id}`, patch),

  /** @param {string} id @param {string} status */
  updateStatus: (id, status) => api.patch(`/leads/${id}/status`, { status }),

  /** @param {string} id */
  remove: (id) => api.delete(`/leads/${id}`),

  // ------------------------------------------------------------ mensagens
  /** @param {string} leadId */
  messages: (leadId) => api.get(`/leads/${leadId}/messages`),

  /** @param {string} leadId @param {{ text: string, sender?: string }} dados */
  sendMessage: (leadId, dados) => api.post(`/leads/${leadId}/messages`, dados),

  // ------------------------------------------------------------ anotações
  /** @param {string} leadId */
  notes: (leadId) => api.get(`/leads/${leadId}/notes`),

  /** @param {string} leadId @param {{ type: string, text: string, reminderAt?: string|null }} dados */
  addNote: (leadId, dados) => api.post(`/leads/${leadId}/notes`, dados),

  /** @param {string} noteId */
  removeNote: (noteId) => api.delete(`/leads/notes/${noteId}`),

  /** @param {string} noteId @param {boolean} done */
  setNoteDone: (noteId, done) => api.patch(`/leads/notes/${noteId}/done`, { done }),
};
